import Vue from "vue";
import "./bootstrap";

import App from "./App.vue";
import router from "./router/index.js";
import { store } from "./store/index.js";
import i18n from "./plugins/i18n/i18n.js";
import './registerServiceWorker'

Vue.config.productionTip = false;

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount("#app");
